import { useState } from 'react';
import { Settings } from 'lucide-react';
import {
  TransactionBuilderPageType,
  useTransactionBuilderStore,
} from '../../components/transaction-builder/useTransactionBuilderStore';
import { TransactionBuilderHeader } from '../../components/transaction-builder/TransactionBuilderHeader';
import { TransactionBuilderFooter } from '../../components/transaction-builder/TransactionBuilderFooter';
import { TransactionSimulationSheet } from '../../components/transaction-builder/transaction-simulation/TransactionSimulationSheet';
import { useBatchSimulation } from '../../components/transaction-builder/useBatchSimulation';

/** One off-chain description applies to the complete ordered cart. */
export function TransactionBuilderDescriptionPage(): React.ReactElement {
  const [isSimulationOpen, setIsSimulationOpen] = useState(false);
  const children = useTransactionBuilderStore(
    (state) => state.batchTransactions
  );
  const description =
    useTransactionBuilderStore((state) => state.description) ?? '';
  const setDescription = useTransactionBuilderStore(
    (state) => state.setDescription
  );
  const navigate = useTransactionBuilderStore(
    (state) => state.navigateForwardToPage
  );
  const { request, revision } = useBatchSimulation();
  return (
    <>
      <TransactionBuilderHeader title="Add a description" showBackButton />
      <div className="mx-auto w-full max-w-[528px] px-4 pt-[50px] pb-24">
        <textarea
          id="description"
          aria-label="Description"
          placeholder="What do these transactions do?"
          autoFocus
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          className="h-[184px] w-full resize-y rounded-[14px] border border-gray-300 bg-background p-5 text-base font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:border-zinc-700"
        />
      </div>
      <TransactionBuilderFooter
        continueButtonText="Continue to review"
        onContinue={() =>
          navigate({ page: TransactionBuilderPageType.REVIEW_PAGE })
        }
        continueButtonDisabled={!description.trim() || children.length === 0}
        secondaryAction={{
          label: 'Simulate transactions',
          icon: <Settings className="size-[15px]" />,
          disabled: !request,
          onClick: () => setIsSimulationOpen(true),
        }}
      />
      {request && (
        <TransactionSimulationSheet
          key={revision}
          open={isSimulationOpen}
          onOpenChange={setIsSimulationOpen}
          source="draft"
          request={request}
        />
      )}
    </>
  );
}
